import { render, staticRenderFns } from "./ShipperDeliveriesFilters.vue?vue&type=template&id=4c40a79c&scoped=true"
import script from "./ShipperDeliveriesFilters.vue?vue&type=script&lang=js"
export * from "./ShipperDeliveriesFilters.vue?vue&type=script&lang=js"
import style0 from "./ShipperDeliveriesFilters.vue?vue&type=style&index=0&id=4c40a79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c40a79c",
  null
  
)

export default component.exports